<div *ngIf="currentState === State.MAIN_SETTINGS_PAGE && statusProtected.reasonId !== 0" fxLayout="column" fxLayoutGap="16px">
  <button
    *ngIf="!isActiveAbsence"
    id="duration-settings"
    mat-raised-button
    class="settingsButton"
    (click)="changeState(State.SELECT_DURATION)"
  >
    {{ 'status_settings.duration' | translate }}:
    {{ statusProtected.defaultDuration ? getDurationToShow() : ('duration.ask_every_time' | translate) }}
  </button>
  <button
    *ngIf="isActiveAbsence"
    mat-raised-button
    class="settingsButton"
    (click)="changeState(State.CHANGE_DURATION)"
    [disabled]="statusProtected.reasonId === 100 || statusProtected.reasonId === 101"
  >
    {{ 'status_settings.change_end_time' | translate }}: {{ statusProtected.endTime | timeAndDateFormatter }}
  </button>
  <button mat-raised-button class="settingsButton" (click)="changeState(State.SELECT_FORWARDING)">
    {{ 'status_settings.forwarding' | translate }}: {{ actionId | forwardingText | translate }}
  </button>

  <mat-slide-toggle class="settingsButton" [(ngModel)]="readReason" (ngModelChange)="sendDefaultsToBackend()"
    >{{ 'status_settings.read_status' | translate }}
  </mat-slide-toggle>
  <mat-slide-toggle class="settingsButton" [(ngModel)]="readTime" (ngModelChange)="sendDefaultsToBackend()" [disabled]="!readReason">
    {{ 'status_settings.read_duration' | translate }}
  </mat-slide-toggle>
  <mat-slide-toggle class="settingsButton" [(ngModel)]="tempLogoutAgent" (ngModelChange)="sendDefaultsToBackend()"
    >{{ 'status_settings.log_out_from_queues' | translate }}
  </mat-slide-toggle>

  <button mat-raised-button (click)="onBack()" color="primary">
    {{ 'global.back' | translate }}
  </button>
</div>

<div *ngIf="currentState === State.CHANGE_DURATION" fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
  <gt-datetime-input [(datetime)]="dateTimeInput"></gt-datetime-input>
  <button id="saveTime" mat-raised-button (click)="changeDuration()" color="primary">
    {{ 'global.save' | translate }}
  </button>
  <button mat-raised-button (click)="changeState(State.MAIN_SETTINGS_PAGE)" color="accent">
    {{ 'global.cancel' | translate }}
  </button>
</div>

<gt-duration-settings
  (backObservable)="changeState(State.MAIN_SETTINGS_PAGE)"
  [status]="statusProtected"
  [login]="login"
  [orgname]="orgname"
  *ngIf="currentState === State.SELECT_DURATION"
></gt-duration-settings>

<gt-forwarding-settings
  (backObservable)="changeState(State.MAIN_SETTINGS_PAGE)"
  [status]="statusProtected"
  [isActiveAbsence]="isActiveAbsence"
  [login]="login"
  [orgname]="orgname"
  (configureServiceObservable)="changeState(State.CONFIGURE_MY_SERVICE)"
  *ngIf="currentState === State.SELECT_FORWARDING && statusProtected.reasonId !== 0"
></gt-forwarding-settings>

<gt-forwarding-settings-status-available
  *ngIf="statusProtected.reasonId === 0"
  [login]="login"
  [orgname]="orgname"
  [status]="statusProtected"
  (backObservable)="onBack()"
></gt-forwarding-settings-status-available>

<gt-myservice-settings
  (backObservable)="changeState(State.SELECT_FORWARDING)"
  [login]="login"
  [orgname]="orgname"
  *ngIf="currentState === State.CONFIGURE_MY_SERVICE"
></gt-myservice-settings>
